import { useNavigate } from 'react-router-dom';

const SetupSupport = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Full Setup &amp; Support Included
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Not tech-savvy? No problem. We make it easy to get started with complete support every step of the way.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-14 h-14 bg-yellow-400 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-user-star-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">1-on-1 Onboarding</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Our expert success rep sets everything up with you, step-by-step. No confusion, no hassle.
            </p>
          </div>
          
          {/* Card 2 */}
          <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-14 h-14 bg-pink-400 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-customer-service-2-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">VIP 24/7 Support</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Anytime you need help, we're here 24/7, just a message away. Need tweaks? We'll guide you through every update.
            </p>
          </div>
          
          {/* Card 3 */}
          <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-14 h-14 bg-purple-400 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-record-circle-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Call Recording</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Every call is recorded. Access all your call recordings so you can review details whenever you need.
            </p>
          </div>
          
          {/* Card 4 */}
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-14 h-14 bg-blue-400 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-notification-3-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Real-Time Notifications</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Get instant alerts via text or email. You'll always know exactly what's happening with your calls.
            </p>
          </div>
        </div>
        
        <div className="mt-16 bg-gradient-to-br from-pink-50 to-purple-50 rounded-3xl p-12 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            You Don't Need to Be a Tech Wizard
          </h3>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Simple, straightforward, and totally covered — so you can focus on doing what you do best!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/demo-call"
              className="whitespace-nowrap px-8 py-4 bg-white hover:bg-gray-50 text-pink-600 font-semibold rounded-lg border-2 border-pink-500 shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer text-center"
            >
              Listen to Live Demo Call
            </a>
            <button 
              onClick={() => navigate('/payment')}
              className="whitespace-nowrap px-8 py-4 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              Sign Up Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SetupSupport;